module.exports = __webpack_public_path__ + "img/内置多种模版.3d6ef275.png";